import React, { useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import SelectInput from '../../../Misc/SelectInput/SelectInput';
import { useAcompanhamentoMetas } from './AcompanhamentoMetascontext';
import { toast } from 'react-toastify';
import { api } from '../../../../services/api';
import { useMisc } from '../../../../contexts/MiscContext';

const MiniModalJustificativa = ({ idDemandaSelecionada }) => {
    const {
        showJustificativa,
        setShowJustificativa,
        justificativas,
        observacao,
        setObservacao,
        justificativaSelecionada,
        setJustificativaSelecionada,
        handleSearch
    } = useAcompanhamentoMetas();

    const { setShowLoading } = useMisc();

    const handleClose = () => {
        setShowJustificativa(false);
        setJustificativaSelecionada(null);
        setObservacao('');
    };

    const handleConfirm = async () => {
        if (!justificativaSelecionada) {
            toast.warning('Selecione uma justificativa!');
            return;
        }

        try {
            setShowLoading(true);

            const id_demanda = idDemandaSelecionada;

            const params = {
                id_justificativa: justificativaSelecionada.value,
                observacao 
            };
            const response = await api.patch(`/corte/controle-enfesto/acompanhamento-metas/update-observacao/${id_demanda}`, params);

            if (response.status === 200) {
                toast.success('Justificativa enviada com sucesso!');
                handleClose();
                handleSearch();
            } else {
                toast.error('Erro ao enviar a justificativa.');
            }
        } catch (error) {
            toast.error('Erro ao enviar a justificativa.');
        } finally {
            setShowLoading(false);
        }
    };

    return (
        <Modal show={showJustificativa} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Justificativa</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Selecione a Justificativa:</Form.Label>
                        <SelectInput
                            placeholder="justificativa"
                            options={justificativas}
                            value={justificativaSelecionada}
                            onChange={setJustificativaSelecionada}
                        />
                    </Form.Group>
                    <Form.Group className="mt-3">
                        <Form.Label>Observação:</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={observacao}
                            onChange={(e) => setObservacao(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MiniModalJustificativa;
